import React from 'react';
import { ChevronRightIcon as ChevronRight } from '@heroicons/react/24/outline';
import tw from 'twin.macro';

interface Props {
  active: boolean;
  children: React.ReactNode;
}

export default function OptionWrapper(props: Props) {
  const { children, active } = props;
  return (
    <div
      css={[
        tw`cursor-pointer select-none rounded-md px-4 pr-8 py-2 bg-neutral-white relative`,
        active && tw`bg-brand-quiet`,
      ]}
    >
      {children}
      <div
        css={[
          tw`absolute right-0 top-0 bottom-0 flex items-center`,
          active && tw`visible`,
          !active && tw`invisible`,
        ]}
      >
        <ChevronRight tw="h-6 w-6 text-neutral-intense text-opacity-40" />
      </div>
    </div>
  );
}
